import { supabaseClient } from "@/lib/supabase/client";
import { forgetLastScope } from "@/lib/last-user";

/**
 * Current access token (refreshed by supabase-js if it expired) and the user
 * it belongs to; null when signed out.
 */
export async function getSessionAuth(): Promise<{
  accessToken: string;
  userId: string;
} | null> {
  const { data } = await supabaseClient.auth.getSession();
  const session = data.session;
  return session
    ? { accessToken: session.access_token, userId: session.user.id }
    : null;
}

/** Sign out locally and remotely, then hand the caller the route to go to. */
export async function signOutEverywhere(
  navigate: (path: string) => void,
): Promise<void> {
  forgetLastScope();
  try {
    await supabaseClient.auth.signOut();
  } catch {
    // The local session may already be gone; the redirect still applies.
  }
  navigate("/sign-in");
}
